(function () {
  document.querySelectorAll('.collapsible-tab-header:not([data-accordion-init])').forEach(function (header) {
    header.setAttribute('data-accordion-init', 'true');
    header.addEventListener('click', function () {
      var isExpanded = header.getAttribute('aria-expanded') === 'true';
      var content = header.nextElementSibling;
      if (isExpanded) {
        header.setAttribute('aria-expanded', 'false');
        content.style.display = 'none';
      } else {
        header.setAttribute('aria-expanded', 'true');
        content.style.display = 'block';
      }
    });
  });
})();